import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import TextInput from '../../../components/ui/TextInput'
import FormDialog from '../../../components/ui/FormDialog'
import FormTextField from '../../../components/ui/form/FormTextField'
import { useZodForm } from '../../../lib/forms/useZodForm'
import { systemParameterFormSchema, type SystemParameterFormValues } from './systemParameterFormSchema'
import type { SystemParameter } from '../types'

interface Props {
  visible: boolean
  initial: SystemParameter | null
  submitting: boolean
  onSubmit: (value: string) => void
  onHide: () => void
}

/** Sistem parametresi düzenleme (020: react-hook-form + zod) — yalnız değer; kod/ad salt-okuma. */
export default function SystemParameterFormDialog({
  visible,
  initial,
  submitting,
  onSubmit,
  onHide,
}: Readonly<Props>) {
  const { t } = useTranslation()
  const { control, handleSubmit, reset } = useZodForm(systemParameterFormSchema, {
    defaultValues: { value: '' },
  })

  useEffect(() => {
    if (visible) reset({ value: initial?.value ?? '' })
  }, [visible, initial, reset])

  const onValid = (v: SystemParameterFormValues) => onSubmit(v.value)

  return (
    <FormDialog
      visible={visible}
      header={t('admin.systemParameters.form.editTitle')}
      submitLabel={t('admin.systemParameters.form.save')}
      submitting={submitting}
      submitDisabled={submitting}
      onSubmit={handleSubmit(onValid)}
      onHide={onHide}
    >
      <div className="admin-form">
        <div className="admin-field">
          <label>{t('admin.systemParameters.form.code')}</label>
          <TextInput value={initial?.code ?? ''} disabled />
        </div>
        <div className="admin-field">
          <label>{t('admin.systemParameters.form.name')}</label>
          <TextInput value={initial?.nameTr ?? ''} disabled />
        </div>
        <FormTextField control={control} name="value" label={t('admin.systemParameters.form.value')} required autoFocus />
      </div>
    </FormDialog>
  )
}
